module.exports = __webpack_public_path__ + "static/img/6578_phase_function_Paper_PointsHejduk_Prediction.4dae416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6578_phase_function_Paper_PointsHejduk_Prediction.png
// module id = gw5j
// module chunks = 0